export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "Administracja": "",
        "Akceptuj": "",
        "Aktywne": "",
        "Aktywne kanały komunikacji": "",
        "Anuluj": "",
        "Bazowy adres domenowy": "",
        "Bieżące powiadomienie w panelu użytkownika.": "",
        "Błąd w kodzie MJML.": "",
        "Brak dostępnych kanałów.": "",
        "Brak informacji o kluczach tego typu powiadomienia.": "",
        "Centrum powiadomień": "",
        "Data utworzenia": "",
        "Data wysłania": "",
        "Dodaj szablon": "",
        "Dodaj wiadomość": "",
        "Dodane przez": "",
        "Domyślna stopka": "",
        "Domyślne logo": "",
        "Dostosuj treść dla tego kanału.": "",
        "Edytuj": "",
        "Edytuj komunikaty": "",
        "Edytuj szablon": "",
        "Edytuj wiadomość": "",
        "Element został usunięty.": "",
        "Filtry zmieniają wynik obiektu. Połącz je z obiektem znakiem pionowej kreski.": "",
        "HTML": "",
        "ID": "",
        "Informacje o powiadomieniu": "",
        "Jak działa wysyłka powiadomień?": "",
        "Kanał może korzystać z konfiguracji domyślnej lub własnej treści. Aby edytować tytuł i treść, wyłącz „Konfiguracja domyślna” i rozwiń jego kartę. Wybór języka przy tytule i treści jest zsynchronizowany. Kanałów wymaganych nie można wyłączyć.": "",
        "Kanały": "",
        "Kanały niedostępne wyłączają odpowiednią kolumnę w tabeli.": "",
        "Kanały wiadomości": "",
        "Klucze": "",
        "Kod MJML jest poprawny.": "",
        "Konfiguracja domyślna": "",
        "Konfiguracja kanałów": "",
        "Konfiguracja treści kanałów": "",
        "Konfigurowalne przez użytkownika": "",
        "Kopiuj HTML": "",
        "Krótka wiadomość tekstowa na telefon.": "",
        "Liquid": "",
        "Lista jest pusta": "",
        "Logo osadzane w treści wiadomości mailowych.": "",
        "Moje szablony": "",
        "Nazwa": "",
        "Nazwa powiadomienia": "",
        "Nazwa pozwalająca rozpoznać wysyłkę na liście. Tytuły wiadomości dla odbiorców ustawisz osobno w poszczególnych kanałach.": "",
        "Nazwa szablonu": "",
        "Nie można go wyłączyć dla wymaganych kanałów.": "",
        "Nie udało się pobrać powiadomień.": "",
        "Nie udało się skopiować kodu HTML.": "",
        "Nie udało się wykonać akcji": "",
        "Nie znaleziono żadnych wyników.": "",
        "Nowy szablon": "",
        "np. Kod promocyjny z newslettera": "",
        "Obiekty przechowują treść wyświetlaną w szablonie. Zapisuj je w podwójnych nawiasach klamrowych.": "",
        "Obsługiwane kanały": "",
        "Określ kanały wysyłki i treść tego typu powiadomienia.": "",
        "Określ tytuł, odbiorcę i termin wysłania.": "",
        "Pełna dokumentacja": "",
        "Poczta wychodząca": "",
        "Pod spodem": "",
        "Podgląd": "",
        "Popraw błędy formularza przed zapisaniem.": "",
        "Potwierdź akceptację": "",
        "Potwierdzenie usunięcia": "",
        "Powiadomienia": "",
        "Powiadomienia mailowe": "",
        "Powiadomienie jest aktywne": "",
        "Powiadomienie niewidoczne w ustawieniach użytkownika": "",
        "Powiadomienie push na urządzeniu odbiorcy.": "",
        "Powiadomienie testowe zostało wysłane.": "",
        "Powiadomienie w Microsoft Teams.": "",
        "Powiadomienie wymagane": "",
        "Powiadomienie wymagane - nie można wyłączyć go globalnie ani w ustawieniach użytkownika.": "",
        "Powiadomienie wymagane.": "",
        "Powiadomienie zbiorowe zostało dodane.": "",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "",
        "Przywróć domyślne": "",
        "Przywrócono ustawienia domyślne.": "",
        "Skopiowano HTML do schowka.": "",
        "Status": "",
        "Status dokumentu został zmieniony.": "",
        "Status powiadomienia": "",
        "Stopka dla wersji": "",
        "Stopkę ustawiasz osobno dla każdej wersji językowej, logo jest wspólne.": "",
        "Strona główna": "",
        "System": "",
        "System powiadomień": "",
        "System szablonów wykorzystuje język Liquid do parsowania treści.": "",
        "Szablon został dodany.": "",
        "Szablon został usunięty.": "",
        "Szablon został zaktualizowany.": "",
        "Szablony email": "",
        "Szukaj powiadomienia": "",
        "Tagi tworzą logikę i sterują przepływem szablonu. Same nie generują widocznej treści.": "",
        "Temat wiadomości widoczny w skrzynce odbiorcy.": "",
        "Ten kanał jest wymagany": "",
        "Ten kanał korzysta z domyślnej konfiguracji.": "",
        "Ten kanał korzysta z domyślnej konfiguracji. W tej wiadomości nie można zmienić jego treści ani włączyć lub wyłączyć wysyłki.": "",
        "Ten kanał korzysta z domyślnej konfiguracji. Wyłącz „Konfiguracja domyślna”, aby edytować jego tytuł i treść.": "",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "",
        "Ten kanał obsługuje tekst sformatowany.": "",
        "Ten kanał obsługuje wyłącznie zwykły tekst.": "",
        "Ten typ powiadomienia jest ukryty w ustawieniach użytkownika - użytkownik nie może sam zmienić jego konfiguracji.": "",
        "Testuj": "",
        "Treść": "",
        "Typ powiadomienia": "",
        "Typ techniczny": "",
        "Typy powiadomień": "",
        "Tytuł": "",
        "Tytuł powiadomienia": "",
        "Tytuł wiadomości dla tego kanału.": "",
        "Układ podglądu": "",
        "Ustawienia": "",
        "Ustawienia powiadomień zostały zaktualizowane.": "",
        "Ustawienia wiadomości": "",
        "Usuń": "",
        "Użytkownik może samodzielnie wybrać dostępne kanały.": "",
        "Wczytywanie": "",
        "Wersje": "",
        "Wiadomość dostępna w historii powiadomień.": "",
        "Wiadomość wysyłana pocztą e-mail.": "",
        "Widoczne dla użytkownika": "",
        "Włącznik wysyłki wszystkich powiadomień.": "",
        "Włączony": "",
        "Własny tytuł i treść dla tego kanału.": "",
        "Wpisz powyżej kod MJML, aby wygenerować podgląd.": "",
        "Wszystko": "",
        "Wybierz kanały wysyłki i dostosuj treść wiadomości dla każdego z nich.": "",
        "Wybierz rolę lub zespół odbiorców oraz termin wysyłki. Możesz użyć kilku kanałów jednocześnie - rozwiń je, aby uzupełnić tytuł i treść w dostępnych językach. Pole „Wysyłaj” włącza kanał, z wyjątkiem kanałów wymaganych. Przed zapisaniem sprawdź odbiorców i przygotowane wiadomości.": "",
        "Wybierz rolę lub zespół, do którego użytkowników ma trafić wiadomość.": "",
        "Wybierz statusy oraz kanały wysyłki dla poszczególnych powiadomień.": "",
        "wybierz...": "",
        "Wygląd wiadomości wysyłanych kanałem mailowym.": "",
        "Wyłączone": "",
        "Wyłączone powiadomienie nie będzie wysyłane.": "",
        "Wyłączony": "",
        "Wymagane": "",
        "Wymaganego powiadomienia nie można wyłączyć w ustawieniach.": "",
        "Wymagany": "",
        "Wymagany do prawidłowego osadzenia logo w treści wiadomości.": "",
        "Wyślij do": "",
        "Wysyłaj": "",
        "Wysyłka tym kanałem jest obowiązkowa i nie można jej wyłączyć dla tej wiadomości. Możesz dostosować tytuł oraz treść komunikatu w dostępnych językach. Przed zapisaniem sprawdź, czy każda wersja zawiera właściwe informacje dla odbiorców.": "",
        "Wysyłka tym kanałem jest obowiązkowa i nie można jej wyłączyć. Po wyłączeniu konfiguracji domyślnej możesz dostosować tytuł oraz treść w dostępnych językach. Przed zapisaniem sprawdź przygotowane wersje komunikatu.": "",
        "Wysyłka wiadomości": "",
        "Z boku": "",
        "Zapisz": "",
        "Zapisz i wróć": "",
        "Zapisz ustawienia": "",
        "Zdarzenia i kanały": "",
        "Zmiana hasła": "",
        "Źródło szablonu": ""
    }
};
